var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#27A6E5",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m16.8 7.56-1.803 9.415s-.252.652-.945.34l-4.16-3.304-.02-.01c.562-.522 4.92-4.58 5.11-4.764.295-.285.112-.455-.23-.24l-6.438 4.234-2.483-.865s-.39-.144-.428-.457c-.039-.314.44-.483.44-.483l10.125-4.113s.832-.379.832.248"
})));
export default SvgTelegram;